/** @jsxImportSource @emotion/react */

import { useState } from "react";
import { css } from "@emotion/react";
import UI from "@mile-meeting/mile-ui";
import RePassword from "./re-password";
import VerifyAccount from "./verify-account";
import BackBtn from "../component/back-btn";
import { updatePassword } from "apis/auth/password";
import { useToast } from "hook/useToast";
import { useNavigate } from "react-router-dom";

const FindPassword = () => {
  const { showToast } = useToast();
  const [step, setStep] = useState<"verify" | "re-password">("verify");
  const [emailVerificationToken, setEmailVerificationToken] = useState<string>("");
  const navigate = useNavigate();

  const onHandleCompleteVerify = () => {
    setStep("re-password");
  };

  const onHandleSettingNewPw = async (password?: string) => {
    if (emailVerificationToken && password) {
      const res = await updatePassword(emailVerificationToken, password);
      if (res.success) {
        navigate("/login", { state: { passwordSettingSuccess: true } });
      } else {
        showToast(res.message ?? "처리 중 문제가 발생하였습니다. 재시도해주세요.", "error");
      }
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <UI.Navigation.TopNav onClickLogo={() => navigate("/login")} />
      <BackBtn onClick={() => (window.location.href = "/login")} />
      {step === "verify" && (
        <VerifyAccount onClickNext={onHandleCompleteVerify} setEmailVerificationToken={setEmailVerificationToken} />
      )}
      {step === "re-password" && <RePassword onClickComplete={onHandleSettingNewPw} />}
    </div>
  );
};

export default FindPassword;
